import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=8a8db276&scoped=true&"
import script from "./Error404.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Error404.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=8a8db276&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8db276",
  null
  
)

export default component.exports